import { render, staticRenderFns } from "./AsientoTemplates.vue?vue&type=template&id=a766d174&"
import script from "./AsientoTemplates.vue?vue&type=script&lang=js&"
export * from "./AsientoTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Users/lucianocolucci/Desktop/Share Windows/IngeniAR/WebProject/Syscore-mods/Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports